function Navigation() {
  return (
    <nav className="navigation">
      <a href="#sobre">Sobre</a>
      <a href="#servicos">Serviços</a>
      <a href="#publicacoes">Publicações</a> {/* novo */}
      <a href="#resultados">Resultados</a>
      <a href="#contato">Contato</a>
    </nav>
  );
}

export default Navigation;
